import React from 'react';
import Page from '../../components/page/page';
import { withTranslation, WithTranslation } from 'react-i18next';

import Notification from '../../components/notification/notification';
import Intro from '../../components/intro/intro';
import Help from '../../components/help/help';
import Social from '../../components/social/social';
import InsurersSlider from '../../components/insurersSlider/insurersSlider';
import Registration from '../../components/registration/registration';
import Partners from '../../components/partners/partners';
import { useSearchParams } from 'react-router-dom';
import { ACCOUNT_ID_PARAM, REGISTRATION_ID_PARAM } from '../../helpers/network';

interface IHomeProps extends WithTranslation {
    warning?: string;
}

const HomePage = (props: IHomeProps) => {
    const { t } = props;
    const [searchParams] = useSearchParams();

    const accountId = searchParams.get(ACCOUNT_ID_PARAM);
    const registrationId = searchParams.get(REGISTRATION_ID_PARAM);
    const hasPreFill = accountId && registrationId;

    const pageContent = (
        <>
            {!hasPreFill ? (
                <div className="home-component">
                    <Intro />
                </div>
            ) : null}

            {props.warning ? (
                <div className="home-warning">
                    <Notification error={true} messages={[{ message: props.warning, weight: 0 }]} />
                </div>
            ) : null}

            <Registration accountId={accountId} registrationId={registrationId} />

            <div className="home-component">
                <Help />
            </div>
            {!hasPreFill ? (
                <>
                    <div className="home-component">
                        <InsurersSlider />
                    </div>
                    <div className="home-component">
                        <Partners />
                    </div>
                </>
            ) : null}

            <div className="home-component">
                <Social />
            </div>
        </>
    );
    return <Page pageTitle={t('home_title')} pageContent={pageContent} />;
};

export default withTranslation()(HomePage);
